// eslint-disable-next-line no-restricted-imports
import { Backdrop } from '@mui/material';
import { styled } from 'libs/ui/styled';

export const BackdropStyled = styled(Backdrop)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
}));
